module.exports = __webpack_public_path__ + "img/p3i0.0fcc5637.png";